export const ActivePointFive = () => (
	<svg width="114" height="124" viewBox="0 0 114 124" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g filter="url(#filter0_ddd_25188_21635)">
			<path
				d="M85 62.375C85 83.2188 61 95 61 95C61 95 37 82.7656 37 62.375C37 48.3608 47.7452 37 61 37C74.2548 37 85 48.3608 85 62.375Z"
				fill="white"
			/>
		</g>
		<path
			d="M60.9998 76.8462C55.1243 76.8462 49.8182 73.499 47.2075 68.3295C46.6901 67.3065 47.1778 66.059 48.255 65.6847C49.1308 65.3802 50.1027 65.7657 50.5212 66.5993C52.4979 70.535 56.5318 73.085 60.9998 73.085C65.4686 73.085 69.5019 70.535 71.4786 66.5993C71.8974 65.7657 72.8695 65.3799 73.7451 65.6847C74.8223 66.059 75.3098 67.3065 74.7926 68.3295C72.1816 73.499 66.8761 76.8462 60.9998 76.8462Z"
			fill="#62BB46"
		/>
		<path
			d="M68.0792 61.3043C68.0792 65.054 64.9926 67.6645 61.1071 67.6645C58.4888 67.6645 56.3395 66.498 55.0165 64.6926C54.8234 64.4149 54.6855 64.026 54.6855 63.6646C54.6855 62.7207 55.4575 61.943 56.422 61.943C56.9183 61.943 57.3864 62.1651 57.662 62.4986C58.5444 63.5539 59.5635 64.1923 60.9967 64.1923C62.8984 64.1923 64.2486 63.0816 64.2486 61.3597C64.2486 59.6375 62.9809 58.721 60.5281 58.721H58.1583C57.0835 58.721 56.2845 57.9154 56.2845 56.8323V50.8884C56.2845 49.8054 57.0835 49 58.1583 49H65.434C66.4257 49 67.1423 49.7219 67.1423 50.6942C67.1423 51.6382 66.4257 52.3882 65.434 52.3882H59.8664V55.4988H61.7683C65.2137 55.4993 68.0792 57.7214 68.0792 61.3043Z"
			fill="#58595B"
		/>
		<defs>
			<filter
				id="filter0_ddd_25188_21635"
				x="0"
				y="0"
				width="114"
				height="124"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB">
				<feFlood flood-opacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="8" />
				<feGaussianBlur stdDeviation="5" />
				<feColorMatrix type="matrix" values="0 0 0 0 0.160784 0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0.1 0" />
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_25188_21635" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="4" />
				<feGaussianBlur stdDeviation="4" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix type="matrix" values="0 0 0 0 0.160784 0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0.05 0" />
				<feBlend mode="normal" in2="effect1_dropShadow_25188_21635" result="effect2_dropShadow_25188_21635" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dx="-4" dy="-4" />
				<feGaussianBlur stdDeviation="16.5" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
				<feBlend mode="normal" in2="effect2_dropShadow_25188_21635" result="effect3_dropShadow_25188_21635" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_25188_21635" result="shape" />
			</filter>
		</defs>
	</svg>
)
